import React from 'react';
import { useTranslation } from "react-i18next";

export default function({ text, var1, var2, var3, var4 }) {
    const { t } = useTranslation();
    let renderText = t(text);

    if (var1) {
       renderText = renderText.replace('[var1]', var1.toString());
    }

    if (var2) {
        renderText = renderText.replace('[var2]', var2.toString());
    }

    if (var3) {
        renderText = renderText.replace('[var3]', var3.toString());
    }

    if (var4) {
        renderText = renderText.replace('[var4]', var4.toString());
    }

    const renderTextSpan = <span dangerouslySetInnerHTML={{__html: renderText}} />;

    return renderTextSpan;
}
